import React from "react";

/**
 * TutorialFigmaFrame — wraps an exported wireframe render (from /tutorial/*.webp)
 * in faux browser chrome so it reads as "this is what the screen looks like in
 * the app." JSX port of the platform V2 component; uses a plain <img> (CRA has
 * no next/image) and degrades gracefully when an image is missing.
 *
 * Props: { src, alt, className }
 */
export default function TutorialFigmaFrame({ src, alt, className = "" }) {
  return (
    <figure
      className={`relative overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg ${className}`}
    >
      {/* Faux browser chrome */}
      <div className="flex items-center gap-2 border-b border-gray-200 bg-gray-50 px-4 py-2.5">
        <span className="h-3 w-3 rounded-full bg-red-400" aria-hidden />
        <span className="h-3 w-3 rounded-full bg-amber-300" aria-hidden />
        <span className="h-3 w-3 rounded-full bg-emerald-400" aria-hidden />
        <span className="ms-3 truncate text-xs text-gray-500">farmtopia.farm</span>
      </div>

      <div className="relative">
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="h-auto w-full"
          onError={(e) => {
            // Some wireframes (e.g. connect-sensor) are not yet exported —
            // hide the broken image rather than show a torn icon.
            e.currentTarget.style.display = "none";
          }}
        />
      </div>
    </figure>
  );
}
